import { useEffect } from 'react';
import { listOrganizationWatchData } from './graphql/queries';

export default function useUsers({ setWatchDataError, useLazyGraphQLQuery }) {
  const [listOrganizationWatchDataQuery, listOrganizationWatchDataResponse] =
    useLazyGraphQLQuery(listOrganizationWatchData);

  useEffect(() => {
    const { error } = listOrganizationWatchDataResponse;

    if (error) {
      setWatchDataError(true);
    }
  }, [listOrganizationWatchDataResponse]);

  return {
    usersWatchData:
      listOrganizationWatchDataResponse.data?.listOrganizationWatchData || [],
    loadingUsersWatchData: listOrganizationWatchDataResponse.loading,
    fetchUsersWatchData: listOrganizationWatchDataQuery,
  };
}
